import { useState } from "react";
import { RefreshCw, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const STEPS = [
  { t: "Use the same account", d: "Sign in here with the email, Google or Apple account you use in the Cast app. If Apple hid your email, choose Continue with Apple." },
  { t: "Restore in the app", d: "Open the Cast app, go to your profile and tap Restore purchases. This links your subscription to your Cast account." },
  { t: "Refresh here", d: "Come back to this page and tap Check my membership. It can take a minute after you subscribe." },
];

export function RestoreHelp() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    const u = await refresh();
    setBusy(false);
    if (u?.is_plus) toast.success("Cast Plus is unlocked. Welcome!");
    else toast("Not unlocked yet. Check the steps above, or try again in a minute.");
  };
  return (
    <section className="card-warm mt-10 p-6 sm:p-8" data-testid="restore-help">
      <h2 className="flex items-center gap-2 font-display text-3xl font-semibold text-slate-900"><Smartphone className="h-6 w-6 text-[#C86D51]" />Subscribed on your phone?</h2>
      <p className="mt-1 text-slate-600">Your membership belongs to your Cast account, so it works on the web too. Signed in as <span className="font-semibold text-slate-800" data-testid="restore-help-email">{user?.email}</span>.</p>
      <ol className="mt-6 space-y-4">
        {STEPS.map((s, i) => (
          <li key={s.t} className="flex gap-4" data-testid={`restore-step-${i}`}>
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#1E293B] text-sm font-semibold text-white">{i + 1}</span>
            <span><span className="block font-semibold text-slate-900">{s.t}</span><span className="text-sm text-slate-600">{s.d}</span></span>
          </li>
        ))}
      </ol>
      <button data-testid="restore-check" disabled={busy} onClick={check} className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#C86D51] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#B35A3F] disabled:opacity-60">
        <RefreshCw className={`h-4 w-4 ${busy ? "animate-spin" : ""}`} />Check my membership
      </button>
      <p className="mt-4 text-xs text-slate-500">Still stuck? Your subscription is managed in the App Store or Google Play settings on your phone.</p>
    </section>
  );
}
